const emptyReceivedCatchups = () => ({ persons: 0, pbp: 0, internalEvents: 0 });

export const resetCatchupStatus = (status) => {
  status.expected = null;
  status.received = emptyReceivedCatchups();
};

export const setExpectedCatchups = (status, expected) => {
  status.expected = { ...expected };
};

const getExpectedCount = (expected, topicSuffix) => {
  const topic = Object.keys(expected).find((key) => key.endsWith(topicSuffix));
  return Number(expected[topic] ?? 0);
};

export const areCatchupsComplete = (status) => {
  if (status.expected === null) return false;

  return (
    status.received.persons >= getExpectedCount(status.expected, "/p/c") &&
    status.received.pbp >= getExpectedCount(status.expected, "/pbp/c") &&
    status.received.internalEvents >= getExpectedCount(status.expected, "/int/c")
  );
};
